import { Link } from 'react-router-dom';

export default function BlogHero() {
  return (
    <section className="relative text-white py-20 overflow-hidden">
      {/* Background image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9cd3796c9909ad335dcab4070fb312f9.jpg')`,
        }}
      />

      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-950/85 via-emerald-900/80 to-teal-900/85" />

      {/* Subtle radial glow overlay */}
      <div className="absolute inset-0 opacity-20"
        style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #E8B84B 0%, transparent 50%), radial-gradient(circle at 80% 20%, #E8B84B 0%, transparent 40%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* Left: Branding */}
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-[#E8B84B]/15 border border-[#E8B84B]/30 text-[#E8B84B] px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest mb-5">
              <span>🧑‍🦲</span>
              <span>The 2 Bald Guys Blog</span>
              <span>🧑‍🦲</span>
            </div>

            <h1 className="font-['Oswald'] text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              No Hair. <span className="text-[#E8B84B]">No BS.</span><br />
              Just the Truth About Cars.
            </h1>

            <p className="text-white/70 text-base sm:text-lg leading-relaxed max-w-xl mb-8">
              Two bald guys who got tired of watching dealers rip people off decided to write about it instead. 
              Unfiltered takes on buying, selling, financing, and everything the dealership hopes you never Google.
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 mb-8">
              {[
                { value: '0', label: 'Dealer Sponsors', icon: 'ri-close-circle-line' },
                { value: '100%', label: 'Unfiltered Opinions', icon: 'ri-fire-line' },
                { value: '∞', label: 'Dealer Tactics Exposed', icon: 'ri-spy-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center lg:text-left">
                  <div className="flex items-center gap-1.5 justify-center lg:justify-start mb-0.5">
                    <i className={`${stat.icon} text-[#E8B84B] text-lg`}></i>
                    <span className="font-['Oswald'] text-2xl font-bold text-white">{stat.value}</span>
                  </div>
                  <div className="text-white/75 text-xs">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
              <Link
                to="/vlog"
                className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1C2B1E] px-5 py-2.5 rounded-full text-sm font-bold hover:bg-[#d4a43a] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-video-line"></i>
                Watch the Vlog
              </Link>
              <Link
                to="/blog/newsletter"
                className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                Get the Newsletter
              </Link>
            </div>
          </div>

          {/* Right: Card */}
          <div className="flex-shrink-0 w-full max-w-sm lg:max-w-xs">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm">
              <div className="flex justify-center gap-4 mb-5">
                {[
                  { emoji: '🧑‍🦲', name: 'Guy #1', title: 'Chief Skeptic', color: 'bg-[#E8B84B]' },
                  { emoji: '🧑‍🦲', name: 'Guy #2', title: 'Head of Honesty', color: 'bg-[#2d4430]' },
                ].map((guy) => (
                  <div key={guy.name} className="text-center">
                    <div className={`w-16 h-16 ${guy.color} rounded-full flex items-center justify-center text-3xl mb-2 mx-auto border-2 border-white/20`}>
                      {guy.emoji}
                    </div>
                    <div className="text-white text-xs font-bold">{guy.name}</div>
                    <div className="text-white/75 text-xs">{guy.title}</div>
                  </div>
                ))}
              </div>

              <div className="bg-white/5 rounded-xl p-4 border border-white/10 mb-4">
                <i className="ri-double-quotes-l text-[#E8B84B] text-xl mb-1 block"></i>
                <p className="text-white/80 text-sm leading-relaxed italic">
                  "We lost our hair so you don't have to lose your shirt at a dealership."
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                {['Dealer Tactics', 'Financing Truth', 'Oregon Coast', 'No Fluff'].map((tag) => (
                  <span key={tag} className="bg-[#E8B84B]/15 text-[#E8B84B] text-xs px-3 py-1 rounded-full border border-[#E8B84B]/20">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-amber-50 to-transparent opacity-30" />
    </section>
  );
}
